import { render, staticRenderFns } from "./LicenseStatus.vue?vue&type=template&id=a1f969b8&scoped=true&"
import script from "./LicenseStatus.vue?vue&type=script&lang=ts&"
export * from "./LicenseStatus.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseStatus.vue?vue&type=style&index=0&id=a1f969b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f969b8",
  null
  
)

export default component.exports